import { Stack, styled } from '@mui/material';

export const FullScreenContainer = styled(Stack)({
    minWidth: '100%',
    minHeight: '100vh',
});
